import * as constants from 'constant/chat';

import { ChatMessage } from 'interface';
import { getUUID } from 'utils';
// import img from 'assets/images/avatar.jpg';
import { Button } from 'primereact/button';
import GreetingQuestions from './GreetingQuestions';

type ComponentPropsWithMessage = {
    message: string;
    isError?: boolean;
} & Omit<any, 'message'>;

type CreateChatMessageProps = {
    type:
    | typeof constants.MESSAGE_TYPE_BOT
    | typeof constants.MESSAGE_TYPE_USER
    | typeof constants.MESSAGE_TYPE_GREETING
    | typeof constants.MESSAGE_TYPE_QUICK_BUTTONS;
    component?: React.ComponentType<any>;
    componentProps?: ComponentPropsWithMessage;
    drafts?: string[];
    timeStamp?: Date;
    chatQueries?: string[];
    handleChatQueryClick?: (chatQuery: string, type?: string, item?: any, answer?: any) => void;
    callback?: (actionQuery: string) => void;
} & (
        | { component: React.ComponentType<any>; componentProps: ComponentPropsWithMessage }
        | { component?: undefined; componentProps?: undefined }
    );
const CreateChatMessage = ({
    type,
    component: Component,
    componentProps,
    timeStamp,
    drafts = null,
    chatQueries = [],
    handleChatQueryClick
}: CreateChatMessageProps): ChatMessage => {
    const chatMessage: ChatMessage = {
        type,
        answerId: getUUID(),
        timeStamp: timeStamp,
        drafts,
        ...(Component && {
            component: ({ shouldDisableComponent }: any) => {
                return type === constants.MESSAGE_TYPE_GREETING ? (
                    <div className={componentProps.isError ? '' : 'greeting-container'}>
                        <div className="greeting__inner">
                            <div className="bot-avatar">
                                <img
                                    src={'https://storage.googleapis.com/seek-logos/ibexco-assests/avatar.jpg'}
                                    alt="bot icon"
                                />
                            </div>
                            <h1>Hi there! If you have questions about ibex, I can help!</h1>
                        </div>

                        <GreetingQuestions {...{ handleChatQueryClick }} />

                        {/* <Component {...componentProps} disabled={shouldDisableComponent} /> */}
                    </div>
                ) : type === constants.MESSAGE_TYPE_QUICK_BUTTONS ? (
                    <GreetingQuestions {...{ handleChatQueryClick }} />
                ) : (
                    <>
                        <div className="chat-bot-logo">
                            <img
                                src={'https://storage.googleapis.com/seek-logos/ibexco-assests/avatar.jpg'}
                                alt="bot icon"
                            />
                        </div>

                        <div className={componentProps.isError ? '' : 'source-container-bot'}>
                            <Component {...componentProps} disabled={shouldDisableComponent} />
                            <div className="button-container">
                                {chatQueries?.map((chatQuery) => {
                                    return (
                                        <div className="button__item">
                                            <Button
                                                className="btn-hover"
                                                severity="secondary"
                                                outlined
                                                rounded
                                                disabled={shouldDisableComponent}
                                                onClick={() => handleChatQueryClick(chatQuery)}>
                                                {chatQuery}
                                            </Button>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                );
            }
        })
    };

    return chatMessage;
};

export default CreateChatMessage;
